import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import client from '../api';
import { EditorState, ContentState, Modifier, RichUtils } from 'draft-js';
import { stateToHTML } from "draft-js-export-html";
import { stateFromHTML } from 'draft-js-import-html';
import '../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useParams } from 'react-router-dom';
import { notifyError } from '../helper';

const DraftEditor = ({emailVariables, className, onContentChange, defaultContent, onFocus, onBlur}) => {
  const api = client();
  const {campaignID} = useParams();
  const [variableArr,setVariableArr] = useState([]);
  const initializeEditorState = () => {
    if (defaultContent) {
      
      const contentState = stateFromHTML(defaultContent);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();

  };
  
  const [editorState, setEditorState] = useState(initializeEditorState);
   // Handle editor state change
   const handleEditorChange = (state) => {
    setEditorState(state);
    const content = state.getCurrentContent();
    //const plainText = content.getPlainText(); // Extract plain text    
    //const rawContent = convertToRaw(content); // Get raw JSON format    
    const htmlContent = stateToHTML(content); // Convert to HTML
    onContentChange(htmlContent); // Pass text to parent
  };

  // Simulating an image upload function
  const uploadImageCallback = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve({ data: { link: reader.result } });
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };
  // Custom toolbar configuration
  const toolbarOptions = {
    options: ["inline", "image", "list", "link","remove", "history"], // Only show these groups. Removed "blockType", "textAlign"
    inline: {
      options: ["bold", "italic","underline"], // Only allow bold, italic, underline
    },
    list: {
      options: ["unordered", "ordered"], // Only unordered and ordered lists
    },
    textAlign: {
      options: ["left", "center", "right"], // Text alignment options 
    },
    link: {
      options: ["link"], // Only link option
    },
    image: {
      urlEnabled: true,
      uploadEnabled: false,
      uploadCallback: uploadImageCallback, // Custom upload function
      previewImage: true,
      alt: { present: true, mandatory: false },
    },
  };
  
  const CustomOption = () => {
    //const variableData = ['firstname','lastname','pagelink','email','date','firstname1','lastname1','pagelink1','email1','date1'];
    const variableData = [...variableArr];
    const [toggleList, setToggleList] = useState(false);

    const toggleVariableList = () => {
      setToggleList(!toggleList);
    }
    
    const placeWordInEditor = (word) => {
      const contentState = editorState.getCurrentContent();
      const selectionState = editorState.getSelection();

      const textToInsert = `{{${word}}}`;
      const newContentState = Modifier.replaceText(
        contentState,
        selectionState,
        textToInsert
      );

    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      "insert-characters"
    );

    setEditorState(newEditorState);
    //onChange(newEditorState);
      //console.log(word);
    }
    return (<>
      <div className="custom-options" onClick={toggleVariableList}>
        <span className="rdw-option-wrapper">INSERT</span>
        {toggleList && <ul className="varialble-list">
          {variableData.map((word,i)=>(<li key={i} onClick={()=>{placeWordInEditor(word)}}>{word}</li>))}
          {<li onClick={()=>{placeWordInEditor('unsubscribe_url')}}>unsubscribe_url</li>}
        </ul>}
      </div>
      </>);
  }

  useEffect(()=>{
    const getValiableList = async () => {
      try{
        const response = await api.post('/v1/campaign/emailVariables/get',{
          campaignID:campaignID
        });
        if(response.status === 200 || response.status === 201){
          setVariableArr(response.data.data.list_data_keys);
        }
      } catch (error){
        console.log('error.message',error);
        if(error.status === 400) notifyError('Bad Request. Unable to fetch variable list. Please try again');
      }
    }
    emailVariables && getValiableList();
  },[]);

  return (<>
  <div style={{ border: "1px solid #ddd", padding: "10px", background: "white" }}>
    <Editor
      toolbar={toolbarOptions}
      wrapperClassName="wrapper-class"
      editorClassName={`editor-class ${className}`}
      toolbarClassName="toolbar-class"
      toolbarCustomButtons={emailVariables && [<CustomOption />]}
      editorState={editorState}
      onEditorStateChange={handleEditorChange}
      onFocus={onFocus} // * never invoked
      onBlur={onBlur} // * never invoked
      editorStyle={{
        minHeight: "200px", // Adjust the height
        maxHeight: "400px", // Optional: Limit maximum height
        overflow: "auto",   // Allow scrolling if content overflows
      }}
    />
    </div>
  </>);
}

export default DraftEditor;